import type { CreditCardListResponse, AnyResponse } from "@b2bportal/card-api";
import {
  type WalletCreditEarnResponse,
  type WalletCreditSummaryResponse,
  hsbcWalletApi,
} from "@b2bportal/hsbc-wallet-api";
import {
  axiosInstance,
  deletePaymentMethod,
  listPaymentMethods,
} from "@hopper-b2b/api";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const walletApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: "/",
  }),
  reducerPath: "wallet",
  tagTypes: ["Wallet"],
  endpoints: (build) => ({
    getWalletCreditSummary: build.query<WalletCreditSummaryResponse, void>({
      queryFn: async () => {
        const { data } =
          await hsbcWalletApi(axiosInstance).apiV0WalletCreditSummaryPost();

        return { data };
      },
      providesTags: ["Wallet"],
    }),
    getWalletCreditEarn: build.query<WalletCreditEarnResponse, void>({
      queryFn: async () => {
        const { data } =
          await hsbcWalletApi(axiosInstance).apiV0WalletCreditEarnPost();

        return { data };
      },
      providesTags: ["Wallet"],
    }),
    listPaymentMethods: build.mutation<CreditCardListResponse, void>({
      queryFn: async () => {
        const data = await listPaymentMethods({});
        return { data };
      },
    }),
    deletePaymentMethodAndList: build.mutation<
      AnyResponse,
      { paymentId: string }
    >({
      queryFn: async ({ paymentId }) => {
        const data = await deletePaymentMethod({
          paymentId,
        });

        return { data };
      },
    }),
  }),
});

export const {
  useGetWalletCreditSummaryQuery,
  useGetWalletCreditEarnQuery,
  useListPaymentMethodsMutation,
  useDeletePaymentMethodAndListMutation,
} = walletApi;

export default walletApi;
